import ChatSessions from './ChatSessions/ChatSessionsContainer';
import ChatMessages from './ChatMessages/ChatMessagesContainer';

export default {
  ChatSessions,
  ChatMessages,
};
